<template>
  <modal>
    <template v-if="page == 1">
      <div class="text-center">
        <progressive-img :src="require('@/assets/images/lp/step1.png')" />
      </div>
      <div class="modal-button flex justify-between">
        <a class="button-primary block w-full" @click="next()">使い方を見る</a>
      </div>
    </template>
    <template v-else-if="page == 2">
      <div class="text-center">
        <progressive-img :src="require('@/assets/images/lp/step2.png')" />
      </div>
      <div class="modal-button flex justify-between">
        <a class="button-primary block w-full" @click="next()">次へ進む</a>
      </div>
    </template>
    <template v-else-if="page == 3">
      <div class="text-center">
        <progressive-img :src="require('@/assets/images/lp/step3.png')" />
      </div>
      <div class="modal-button flex justify-between">
        <a class="button-primary block w-full" @click="next()">次へ進む</a>
      </div>
    </template>
    <template v-else-if="page == 4">
      <div class="text-center">
        <progressive-img :src="require('@/assets/images/lp/step4.png')" />
      </div>
      <div class="modal-button flex justify-between">
        <a class="button-primary block w-full" @click="next()">次へ進む</a>
      </div>
    </template>
    <template v-else-if="page == 5">
      <div class="text-center">
        <progressive-img :src="require('@/assets/images/lp/step5.png')" />
      </div>
      <div class="modal-button flex justify-between">
        <a class="button-primary block w-full" @click="next()">次へ進む</a>
      </div>
    </template>
    <template v-else-if="page == 6">
      <div class="text-center">
        <progressive-img :src="require('@/assets/images/lp/step6.png')" />
      </div>
      <div class="modal-button flex justify-between">
        <a class="button-primary block w-full" @click="next()">次へ進む</a>
      </div>
    </template>
    <template v-else-if="page == 7">
      <div class="text-center">
        <progressive-img :src="require('@/assets/images/lp/step7.png')" />
      </div>
    </template>
    <div class="modal-button flex justify-between mt-2">
      <a class="button-primary block w-full" @click="close()">利用してみる</a>
    </div>
  </modal>
</template>

<script>
import Modal from "../atoms/Modal"

export default {
  name: 'LandingModal',
  components: {
    Modal
  },
  props: {
    closeModal: {
      type: Function,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      page: 1,
    }
  },
  methods: {
    next: function () {
      this.page++
    },
    close: function () {
      this.$store.dispatch('user/closeLanding')
      this.closeModal()
    }
  }
}
</script>
